import {
  GET_REPORT_SCHEMA,
  GET_REPORT_SCHEMA_SUCCESS,
  GET_REPORT_SCHEMA_FAILURE,
  RUN_REPORT,
  RUN_REPORT_SUCCESS,
  RUN_REPORT_FAILURE,
} from './actionType';

const initialState = {
  schemaData: {},
  schemaLoading: false,
  schemaError: null,
  resultRows: null,
  resultLoading: false,
  resultError: null,
};

const Reporting = (state = initialState, action) => {
  switch (action.type) {
    case GET_REPORT_SCHEMA:
      return { ...state, schemaLoading: true, schemaError: null };
    case GET_REPORT_SCHEMA_SUCCESS:
      return {
        ...state,
        schemaData: Array.isArray(action.payload)
          ? action.payload[0]
          : action.payload,
        schemaLoading: false,
      };
    case GET_REPORT_SCHEMA_FAILURE:
      return {
        ...state,
        schemaLoading: false,
        schemaError: action.payload,
      };
    case RUN_REPORT:
      return { ...state, resultLoading: true, resultError: null };
    case RUN_REPORT_SUCCESS: {
      const payload = Array.isArray(action.payload)
        ? action.payload[0]
        : action.payload;
      return {
        ...state,
        resultRows: payload?.row_list || [],
        resultLoading: false,
      };
    }
    case RUN_REPORT_FAILURE:
      return {
        ...state,
        resultRows: null,
        resultLoading: false,
        resultError: action.payload,
      };
    default:
      return state;
  }
};

export default Reporting;
